import Restraint from "./Restraint.js";
import Maths3 from "oc-threejs/Maths3.js";
import Scenes from "oc-threejs/Scenes.js";
import {v3} from "oc-threejs/short3.js";
import Commons from "oc-commons/Commons";
import PlaneRestraint from "./PlaneRestraint";
import OcAxisHelper from "oc-threejs/objects/OcAxisHelper";
import AnchorAwareMixin from "./AnchorAwareMixin";

/**
 * Wie PlaneRestraint, aber begrenzt durch eine Box. Die Ebene läuft durch den Mittelpunkt der
 * Box, nur die Normale (normal) muss angegeben werden.
 */
export default class PlaneInBoxRestraint extends PlaneRestraint {

    /** @type {THREE.Box3} */
    boxAroundPlane;

    constructor(options) {
        super(Commons.defaultsDeepSafe(options,{
            plane: new THREE.Plane().setFromNormalAndCoplanarPoint(options.normal,v3()),
        }));
        this.boxAroundPlane = options.box;
    }

    /**
     * @param {THREE.Ray} ray
     * @returns {?THREE.Vector3}
     */
    raycastLocal(ray) {
        if (!ray.intersectBox(this.boxAroundPlane)) {
            return null;
        }
        return super.raycastLocal(ray);
    }

    createDebugVisualization() {
        const parent = new THREE.Object3D();
        // const box = Scenes.box(this.boxAroundPlane.getSize(),new THREE.MeshBasicMaterial({color:0x0000aa,transparent:true,opacity:0.3}));
        const box = Scenes.wireframe(Scenes.box(this.boxAroundPlane.getSize()),1,STAGE.settings.dragDrop.restraintsDebugColor);
        box.position.copy(this.boxAroundPlane.getCenter());
        parent.add(box);
        return parent;
    }

}
